import React from 'react'
import { Box, Button, Grid, Typography } from '@mui/material'

import climber from '../../../assets/images/risk-assessment/climber.png'

export function RiskTolerance({ onNext, key }) {
  return (
    <Grid key={key} item xs={12} mb={3}>
      <Box>
        <Typography
          variant="headerTitle"
          sx={{ color: '#262627', fontSize: { xs: '24px', sm: '32px' } }}
        >
          What level of risk suits you best?
        </Typography>
      </Box>
      <Typography mt={2} sx={{ color: '#495057', fontSize: 18 }}>
        Sure everyone wants to maximize their returns – but not everyone’s
        comfortable with the ups and downs that come with long-term investing.
        Whether you like to play it safe, take big bets, or both, how do you get
        the highest return for your comfort zone?
      </Typography>

      <Box mt={4} display="flex" alignItems="center" justifyContent="center">
        <img
          src={climber}
          width={200}
          height={200}
          style={{
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
          alt="Risk assessment climber illustration"
        />
      </Box>

      <Box mt={3} display="flex" gap={2} justifyContent="flex-end">
        <Button variant="parcoRounded" onClick={onNext}>
          Find out my Risk Tolerance
        </Button>
      </Box>
    </Grid>
  )
}
